export const example = `======= Oceniasz starannie dluga zdobiona mizerykordie. ========

Masz przed soba dosc niezwykly okaz sztyletu. Mizerykordia ta charakteryzuje sie dluga klinga, ktora
pokrywa siec roslinnych zdobien. Ostre krawedzie sztyletu zahartowano i pokryto cieniutka warstwa
srebra, aby uzyskac jeszcze wieksza jakosc, dodatkowo poprawiajac walory estetyczne broni. Rekojesc
od ostrza oddzielaja waskie, stalowe jelce, ktore  skutecznie chronia dlon dzierzacego przed
potencjalnym zagrozeniem ze strony wrogiego oreza.
Wyglada na to, ze jest w znakomitym stanie. [max]

Oceniasz, ze dluga zdobiona mizerykordia wazy 640 gramow, zas jej objetosc wynosi 180 mililitrow.
Wydaje ci sie, ze jest warta okolo 730 miedziakow, czyli 3 zl, 10 mdz.


 Typ broni: sztylet                          Chwyt: w dowolnej rece
 Obrazenia: klute
 Wywazenie: doskonale [12/14]                Skutecznosc: dosyc skuteczne [8/14]

 Suma: 20                                    Srednia: 10

Do wykonania tej broni uzyto srebra, bedzie wiec ona skuteczna przeciw wrogom odpornym na zwykle
obrazenia.

======= Oceniasz starannie srebrzysta kose bojowa. ========

Widzisz niesamowita bron, srebrzysta kose bojowa, tak ostra, ze moglaby ona przeciac w locie motyla.
Azurowe ostrze wykonane jest ze stali o srebrzystej barwie, polyskujacej wlasna, magiczna poswiata.
Jest ono osadzone na dlugim drzewcu, dodatkowo wzmocnionym stalowymi okuciami. Zaraz ponizej ostrza,
na drzewcu, widnieja dziwne znaki, najprawdopodobniej runy. Bron ta nieodparcie przywodzi ci na mysl
smierc.
Wyglada na to, ze jest w znakomitym stanie. [max]

Oceniasz, ze srebrzysta kosa bojowa wazy 7200 gramow, zas jej objetosc wynosi 1400 mililitrow.
Wydaje ci sie, ze jest warta okolo 2500 miedziakow, czyli 10 zl, 8 sr, 4 mdz.
Wyglada na to, ze moglaby ci jeszcze raczej krotko (6h-1d) sluzyc.


 Typ broni: bron drzewcowa                   Chwyt: oburacz
 Obrazenia: ciete
 Wywazenie: genialnie [14/14]                Skutecznosc: fantastycznie skuteczne [14/14]

 Suma: 28                                    Srednia: 14

Sadzac po delikatnym drzeniu w broni tej zostala zakleta jakas magia, bedzie wiec ona skuteczna
przeciw wrogom odpornym na zwykle obrazenia.

======= Oceniasz starannie grawerowana pelna zbroje plytowa. ========

Ta pelna zbroja plytowa zlozona jest z mnogosci elementow spojonych w calosc skorzanymi rzemieniami
i metalowymi bolcami. Do najwiekszej z plyt, napiersnika, przyczepione sa folgowe taszki, chroniace
dodatkowo uda okryte naudziakami. Nizej, przez zginane nakolanka doczepione sa nagolenniki zespolone
z metalowymi trzewikami o okraglych nosach, przystosowane raczej do poruszania sie pieszo niz
wierzchem. Rece chronia naramienniki, opachy, folgowe nalokcice i konczace sie przed dlonmi
zarekawia. Wszystko to podbite jest dla wygody cienkim filcem. Kazda z wiekszych plyt grawerowana
jest gesto przy brzegach w splecione w lancuch roslinne pedy nakrapiane tu i owdzie plamami
zloconych lilii.
Wyglada na to, ze jest w znakomitym stanie. [max]

Oceniasz, ze grawerowana pelna zbroja plytowa wazy 32 kilogramy, zas jej objetosc wynosi 10000
mililitrow.
Wydaje ci sie, ze jest warta okolo 5600 miedziakow, czyli 23 zl, 6 sr, 8 mdz.
Zaklada sie ja na korpus, nogi, ramiona, stopy i dlonie.

 Typ zbroi: ciezka                           Klute: dosc dobrze [8/12]
 Ciete: bardzo dobrze [10/12]                Obuchowe: bardzo dobrze [10/12]

 Suma: 28                                    Srednia: 9.33

 ======= Oceniasz starannie foremny obreczowy helm. ========

 Ten otwarty, lekko stozkowaty helm wykonany zostal na bazie nitowanego szkieletu z wytrzymalego,
 polyskujacego srebrzyscie metalu. Wprawione wen plytki sa inkrustowane szmaragdowa, polprzezroczysta
 emalia, nadajaca calosci dosc niespotykanego, ekscentrycznego wygladu. Zbroja pozbawiona jest nosala
 oraz oslaniajacych policzki plytek, jednak posiada ochraniajaca kark, krotka, metalowa plecionke.
 Wyglada na to, ze jest w znakomitym stanie. [max]

 Oceniasz, ze foremny obreczowy helm wazy 2500 gramow, zas jego objetosc wynosi 620 mililitrow.
 Wydaje ci sie, ze jest wart okolo 300 miedziakow, czyli 1 zl, 5 sr.
 Zaklada sie go na glowe.

  Typ zbroi: lekka                            Klute: dosc dobrze [8/12]
  Ciete: perfekcyjnie [12/12]                 Obuchowe: bardzo dobrze [10/12]

  Suma: 30                                    Srednia: 10`;
